import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-dream-navy flex flex-col items-center justify-start px-6 pt-12 pb-[max(2rem,env(safe-area-inset-bottom))] md:justify-center md:pt-8">
      <div className="w-full max-w-[400px]">
        <div className="mb-8 flex justify-center">
          <img src="/logo-dreamable.svg" alt="Dreamable" className="h-8 md:h-10" />
        </div>
        <Outlet />
      </div>
    </div>
  );
}
